module.exports = __webpack_public_path__ + "img/07_shimizu_20.e75748e1.jpg";